import React from 'react';
import { Toggle } from 'rsuite';
import './ToggleWithInfo.scss';

const ToggleWithInfo = ({ checked, label, onChange, disabled, info = "", className = ""}) => {
    return (
        <div className={`toggle-info-container ${className}`}>
            <div className='toggle-container'>
                <Toggle
                    className='toggle'
                    onChange={onChange}
                    disabled={disabled}
                    size="md"
                    checked={checked}
                    />
                <span className='label'>{label}</span>
            </div>
            <span className='info'>{info}</span>
        </div>
    );
}

export default ToggleWithInfo;